import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-200 px-6" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500/80 mb-3">404</p>
        <h1 className="text-4xl font-semibold tracking-tight" style={{ fontFamily: "var(--font-heading)" }}>Page not found</h1>
        <p className="mt-3 text-zinc-400">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="inline-block mt-6 bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg text-sm font-medium" data-testid="not-found-home-btn">
          Go home
        </Link>
      </div>
    </div>
  );
}
